import { useEffect, useMemo, useState } from 'react';
import throttle from 'lodash/throttle';
import isNull from 'lodash/isNull';

const getViewportWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

export default function useHandleableViewportResize(callback, ms = 16) {
  const [width, setWidth] = useState(null);

  const resizeListener = useMemo(
    () =>
      throttle(() => setWidth(getViewportWidth()), ms, {
        leading: true,
        trailing: true,
      }),
    [ms]
  );

  useEffect(() => {
    if (!isNull(width)) {
      callback();
    }
  }, [width, callback]);

  useEffect(() => {
    window.addEventListener('resize', resizeListener);

    return () => {
      window.removeEventListener('resize', resizeListener);
    };
  }, [resizeListener]);
}
